import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Grid } from 'components/base';

const StyledCol = styled(Grid.Col)`
  max-width: 150px;
  display: flex;
  align-items: center;

  p {
    margin-bottom: 0;
  }
`;

const EventFormControl = props => (
  <Grid.Row className="mb-1">
    <StyledCol xs={4}>{props.label}</StyledCol>
    <StyledCol xs={8} className={props.className}>
      {props.children}
    </StyledCol>
  </Grid.Row>
);

EventFormControl.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

EventFormControl.defaultProps = {
  className: 'mw-300',
};

export default EventFormControl;
